import { typedAction } from "../helpers";
import { ADD_WORKING_DIRECTORY, REMOVE_WORKING_DIRECTORY, RESET_WORKING_DIRECTORY, REMOVE_WORKING_DIRECTORIES_BY_INDEX, REMOVE_WORKING_DIRECTORIES_BY_INDEX_INDEX_AND_ADD_ITEM, SET_ONE_DRIVE_DETAILS, ADD_WORKING_DIRECTORIES, SET_WORKING_DIRECTORIES } from "./actionTypes";
import { WorkingDirectoryState } from "../models/reduxModels";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { IBreadcrumbItem } from "@fluentui/react";
import { IOneDriveRootDetails } from "../../interfaces/IOneDriveRootDetails";
import { logger } from "../../../../utilities/logger";

const initialState: WorkingDirectoryState = { workingDirectories: [] };

export const addWorkingDirectory = (location: IPageSettings) => {
    return typedAction(ADD_WORKING_DIRECTORY, location);
};

export const addWorkingDirectories = (locations: IPageSettings[]) => {
    return typedAction(ADD_WORKING_DIRECTORIES, locations);
};

export const setWorkingDirectories = (locations: IPageSettings[]) => {
    return typedAction(SET_WORKING_DIRECTORIES, locations);
}

export const setOneDriveDetails = (oneDriveDetails: IOneDriveRootDetails) => {
    return typedAction(SET_ONE_DRIVE_DETAILS, oneDriveDetails);
}

export const removeTopWorkingDirectory = () => {
    return typedAction(REMOVE_WORKING_DIRECTORY);
}

export const resetWorkingDirectories = (locations?: IPageSettings[], registerHistory: boolean = true) => {
    return typedAction(RESET_WORKING_DIRECTORY, { locations, registerHistory });
}

export const removeDirectoriesByIndex = (item: IBreadcrumbItem) => {
    return typedAction(REMOVE_WORKING_DIRECTORIES_BY_INDEX, item)
}

export const removeDirectoriesByIndexAndAddItem = (index: number, location: IPageSettings) => {
    return typedAction(REMOVE_WORKING_DIRECTORIES_BY_INDEX_INDEX_AND_ADD_ITEM, { index, location })
}

type WorkingDirectoryAction = ReturnType<typeof addWorkingDirectory
    | typeof removeTopWorkingDirectory
    | typeof resetWorkingDirectories
    | typeof removeDirectoriesByIndex
    | typeof removeDirectoriesByIndexAndAddItem
    | typeof setOneDriveDetails
    | typeof addWorkingDirectories
    | typeof setWorkingDirectories>;

export function workingDirectoryReducer(
    state = initialState,
    action: WorkingDirectoryAction
): WorkingDirectoryState {
    switch (action.type) {
        case SET_ONE_DRIVE_DETAILS:
            return { ...state, oneDriveRootDetails: action.payload };
        case ADD_WORKING_DIRECTORY: {
            const updatedWorkingDirectories: IPageSettings[] = [...state.workingDirectories, action.payload];
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories };
        }
        case ADD_WORKING_DIRECTORIES: {
            const updatedWorkingDirectories: IPageSettings[] = [...state.workingDirectories, ...action.payload];
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories };
        }
        case SET_WORKING_DIRECTORIES: {
            const updatedWorkingDirectories: IPageSettings[] = [...action.payload];
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories };
        }
        case REMOVE_WORKING_DIRECTORY: {
            const updatedWorkingDirectories: IPageSettings[] = [...state.workingDirectories.slice(0, state.workingDirectories.length - 1)];
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories };
        }
        case RESET_WORKING_DIRECTORY: {
            const updatedWorkingDirectories: IPageSettings[] = !action.payload.locations
                ? []
                : [...action.payload.locations];
            if (action.payload.registerHistory === true) {
                registerHistoryEntry(updatedWorkingDirectories);
            }
            return { workingDirectories: updatedWorkingDirectories, oneDriveRootDetails: state.oneDriveRootDetails }
        }
        case REMOVE_WORKING_DIRECTORIES_BY_INDEX: {
            // const index = state.workingDirectories.findIndex(directory => directory.id === action.payload.key);
            // return { ...state, workingDirectories: [...state.workingDirectories.slice(0, index + 1)] }
            const updatedWorkingDirectories: IPageSettings[] = [...state.workingDirectories.slice(0, parseInt(action.payload.key) + 1)];
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories }
        }
        case REMOVE_WORKING_DIRECTORIES_BY_INDEX_INDEX_AND_ADD_ITEM: {
            const updatedWorkingDirectories = [...state.workingDirectories.slice(0, action.payload.index)];
            updatedWorkingDirectories.push(action.payload.location);
            registerHistoryEntry(updatedWorkingDirectories);
            return { ...state, workingDirectories: updatedWorkingDirectories }
        }
        default:
            return state;
    }
}

const registerHistoryEntry = (updatedWorkingDirectories: IPageSettings[]) => {
    if (history?.pushState) {
        try {
            const cleanUrl = window.location.href
                .split("?")[0]
                .split("#")[0];

            history.pushState(updatedWorkingDirectories, "", cleanUrl + "#" + (updatedWorkingDirectories?.map(x => x.displayName?.trim())?.join("/")?.replace(/ /g, "-")?.replace(/[^a-zA-Z0-9-_./:?&=]+/g, "")?.replace(/-+/g, "-") || "Home"));

            if (updatedWorkingDirectories?.length) {
                let locationTitle: string;
                for (let i = updatedWorkingDirectories.length - 1; i > -1; i--) {
                    if (updatedWorkingDirectories[i]?.siteDisplayName) {
                        locationTitle = updatedWorkingDirectories[i].siteDisplayName;
                        break;
                    }
                }

                if (!locationTitle) {
                    locationTitle = updatedWorkingDirectories[updatedWorkingDirectories.length - 1].displayName?.trim();
                }

                document.title = (locationTitle || "Home") + " | Docubird";
            }
            else {
                document.title = "Home | Docubird";
            }
        } catch (error) {
            logger(error, "workingDirectory.ts (registerHistoryEntry)");
            document.title = "Docubird";
        }
    }
}